import React from "react";
import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { PRICING } from "../data/entrepminds";

const goTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-24 md:py-32 bg-[#f3eedf]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="section-eyebrow mb-4">Engagement Packages</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05]">
            Pricing built for{" "}
            <span className="gold-text">measurable transformation</span>.
          </h2>
          <p className="mt-6 text-[#6b6356] text-base md:text-lg">
            Not consulting hours — a fixed, transparent subscription to your
            business&apos;s growth engine.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-6 items-stretch">
          {PRICING.map((tier, idx) => (
            <motion.div
              key={tier.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              data-testid={`pricing-tier-${tier.id}`}
              className={`em-card p-8 flex flex-col relative ${
                tier.featured
                  ? "lg:scale-[1.04] border-[#b8901f] em-glow"
                  : ""
              }`}
            >
              {tier.featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-[#0a0a0a] text-[#d4af37] text-xs font-semibold uppercase tracking-wider rounded-full flex items-center gap-1.5">
                  <Star size={12} fill="#d4af37" />
                  Most Popular
                </div>
              )}

              <div className="font-mono-em text-xs text-[#8a6a10] tracking-[0.25em] uppercase mb-3">
                {tier.audience}
              </div>
              <h3 className="font-display text-3xl mb-6">{tier.name}</h3>

              <div className="border-y border-[#e8e2cf] py-6 my-2">
                <div className="flex items-baseline gap-2">
                  <span className="font-display text-4xl font-semibold gold-text">
                    {tier.setup}
                  </span>
                  <span className="text-sm text-[#6b6356]">setup</span>
                </div>
                <div className="flex items-baseline gap-2 mt-3">
                  <span className="font-display text-2xl text-[#0a0a0a]">
                    {tier.monthly}
                  </span>
                  <span className="text-sm text-[#6b6356]">/ month</span>
                </div>
                <div className="font-mono-em text-[11px] text-[#6b6356] mt-3 tracking-wider">
                  {tier.contract}
                </div>
              </div>

              <ul className="space-y-3 mt-6 flex-1">
                {tier.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-[#3f3a30]">
                    <Check
                      size={16}
                      className="text-[#8a6a10] mt-0.5 shrink-0"
                    />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                data-testid={`pricing-cta-${tier.id}`}
                onClick={() => goTo("contact")}
                className={`mt-8 w-full justify-center ${
                  tier.featured ? "btn-gold" : "btn-ghost"
                }`}
              >
                Choose {tier.name.split(" ").pop()}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
